import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

import './index.css'
import ThemeContext from '../../context/ThemeContext';

const SkillCard = (props) => {
    const { details } = props
    const { name, logo_url, image_url, description } = details
    return (
        <ThemeContext.Consumer>{value => (
        <Popup
            trigger={<li className={`skill-card ${value.theme==='dark'?'dark-mode':''}`}> <img src={logo_url} alt={name} className="skill-card-image" /><h1 className="skill-card-heading">{name}</h1></li>}
            modal
        >
            {close => (
                <div className='modal-card'>
                    <div className='modal-card-container'>
                        <img src={image_url} alt={name} className='modal-card-image' />
                        <div className='modal-card-content'>
                            <h1 className="modal-heading"> {name} </h1>
                            <p className="modal-description">
                                {description}
                            </p>
                            <button onClick={close} className="modal-card-close-button">Close</button>
                        </div>
                    </div>
                </div>
            )}
        </Popup>)}
        </ThemeContext.Consumer>
    )
}
export default SkillCard